import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1892.10042,374.225941 L1517.87448,0 L1143.76011,374.225941 L1222.64435,453.110181 L1462.08647,213.668061 L1462.08647,692.663877 C1462.08647,884.128312 1345.48954,954.198047 1210.37099,1035.31381 C1118.76709,1090.20921 1020.02232,1150.2371 959.994421,1252.21757 C900.078103,1150.2371 801.333333,1090.20921 709.729428,1035.31381 C574.610879,954.198047 457.902371,884.128312 457.902371,692.663877 L457.902371,213.668061 L697.456067,453.110181 L776.340307,374.225941 L402.114365,0 L28,374.225941 L106.88424,453.110181 L346.32636,213.668061 L346.32636,692.663877 C346.32636,947.391911 509.004184,1044.90934 652.490934,1130.93445 C787.609484,1212.05021 904.206416,1282.11994 904.206416,1473.69596 L904.206416,1920 L1015.78243,1920 L1015.78243,1473.69596 C1015.78243,1282.11994 1132.49093,1212.05021 1267.60948,1130.93445 C1411.09623,1044.90934 1573.66248,947.391911 1573.66248,692.663877 L1573.66248,213.668061 L1813.21618,453.110181 L1892.10042,374.225941 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMasteryPathsLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMasteryPathsLine, _Component);

  var _super = _createSuper(IconMasteryPathsLine);

  function IconMasteryPathsLine() {
    _classCallCheck(this, IconMasteryPathsLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMasteryPathsLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMasteryPaths",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMasteryPathsLine.displayName = "IconMasteryPathsLine";
  return IconMasteryPathsLine;
}(Component);

IconMasteryPathsLine.glyphName = 'mastery-paths';
IconMasteryPathsLine.variant = 'Line';
IconMasteryPathsLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMasteryPathsLine;
export { IconMasteryPathsLine };